import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderInfo } from 'app/shared';
import { ClientEditorComponent } from '../client-editor/client-editor.component';
import { compileText } from 'app/planner/print-dialog/template-compiler';

@Component({
  selector: 'app-order-editor',
  templateUrl: './order-editor.component.html',
  styleUrls: ['./order-editor.component.scss']
})
export class OrderEditorComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<OrderEditorComponent>,
      @Inject(MAT_DIALOG_DATA) public order: OrderInfo) {
  }

  ngOnInit() {
  }

  @ViewChild(ClientEditorComponent, {static: true}) clientEditor: ClientEditorComponent;

  async sendOrder() {
    if (this.clientEditor.form.valid) {
      this.order.client = this.order.client || this.clientEditor.form.value;
      let newOrder = { ...this.order };
      if (newOrder.client && this.clientEditor) {
        newOrder.client = this.clientEditor.client;
      }
      let projectNameTemplate = this.clientEditor.orderSettings.projectName;
      if (projectNameTemplate) {
        let context = { client: newOrder.client };
        newOrder.name = await compileText(projectNameTemplate, context);
      }
      this.dialogRef.close(newOrder);
    }
  }

}
